import { IDetailCellRendererParams } from "ag-grid-community";
import { DetailRendererNumParam } from "./DetailRendererNumParam";
import { SetNonNullable } from "type-fest";
import { ParamsEditorRowDatum } from "components/ToolEditor/ToolEditor.types";
import { DetailRendererToolPathParam } from "./DetailRendererToolPathParam/DetailRendererToolPathParam";
import { ToolParamV3 } from "types/json-schemas/type_guards";
import { ToolEditorStoreState } from "components/ToolEditor/Provider/store/ToolEditorProvider.store";
import { DetailRendererStringChoiceParam } from "./DetailRendererToolChoiceParam/DetailRendererStringChoiceParam";

const NoConfig = () => (
  <>No additional configuration available for this parameter type</>
);

export type DetailRendererBaseProps = SetNonNullable<
  Pick<IDetailCellRendererParams<ParamsEditorRowDatum>, "data">,
  "data"
> & {
  updateSpecParam?: ToolEditorStoreState["updateSpecParam"];
  editMode?: boolean;
};

export const DetailRendererBase = ({
  data,
  updateSpecParam,
  editMode = true,
}: DetailRendererBaseProps) => {
  const paramType = data.type.param_type;
  switch (paramType) {
    case "ToolPathParam": {
      return (
        <DetailRendererToolPathParam
          data={
            data as Extract<
              ToolParamV3,
              { type: { param_type: "ToolPathParam" } }
            >
          }
          updateSpecParam={updateSpecParam}
          editMode={editMode}
        />
      );
    }
    case "ToolStringParam": {
      return <NoConfig />;
    }
    case "ToolFloatRangeParam":
    case "ToolIntRangeParam":
      return (
        <DetailRendererNumParam
          data={data}
          type={paramType}
          updateSpecParam={updateSpecParam}
          editMode={editMode}
        />
      );
    case "ToolChoiceParam": {
      // checked above
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return <DetailRendererStringChoiceParam data={data} />;
    }
    case "ToolBooleanParam": {
      return <NoConfig />;
    }
    case "ToolRoiFrameParam": {
      return <NoConfig />;
    }
    case "ToolCellStatusParam": {
      return <NoConfig />;
    }
  }
};
